export default __webpack_public_path__ + "static/media/navigator.48837add.svg";